import React from 'react';
import { MODAL_TITLES } from '../constants';

function SalesModal({
  salesModal,
  salesModalForm, setSalesModalForm,
  cerrarModalVentas,
  guardarAccionVentasModal,
  submittingSalesModal,
}) {
  if (!salesModal.open) return null;

  const tipo = salesModal.type;
  const title = MODAL_TITLES[tipo] || 'AcciÃ³n comercial';
  const updateForm = (patch) => setSalesModalForm((prev) => ({ ...prev, ...patch }));

  const requerido = (valor) => String(valor || '').trim() ? '' : ' Â· obligatorio';

  // Telegram preview for confirmar
  const telegramPreview = tipo === 'confirmar' ? `ðŸŸ¢ NUEVA VENTA CONFIRMADA

Cliente: ${salesModalForm.nombre_apellido || '(pendiente)'}
TelÃ©fono: ${salesModalForm.telefono || '(pendiente)'}
CUIL/DNI: ${salesModalForm.cuil || '(pendiente)'}
Email: ${salesModalForm.email || 'No informado'}

DirecciÃ³n: ${salesModalForm.direccion || '(pendiente)'}
Entre calles: ${salesModalForm.entre_calle_1 || 'No informado'} ${salesModalForm.entre_calle_2 ? 'y ' + salesModalForm.entre_calle_2 : ''}
Localidad: ${salesModalForm.localidad || '(pendiente)'}
Latitud: ${salesModalForm.latitud || 'Pendiente IA'}
Longitud: ${salesModalForm.longitud || 'Pendiente IA'}

Plan: ${salesModalForm.plan || '(pendiente)'}
Precio: ${salesModalForm.precio || '(pendiente)'}
Medio de pago: ${salesModalForm.medio_pago || '(pendiente)'}

Observaciones instalaciÃ³n: ${salesModalForm.observaciones || 'No informado'}
Confirmado por: ${salesModalForm.agente_nombre || 'Agente'}
Origen: IA + validaciÃ³n humana` : '';

  return (
    <div className="modal-overlay" onClick={cerrarModalVentas}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <span className="modal-title">ðŸ“‹ {title}</span>
          <button className="modal-close" onClick={cerrarModalVentas}>âœ•</button>
        </div>

        <div className="modal-body">
          {/* â”€â”€ CONTACTAR â”€â”€ */}
          {tipo === 'contactar' && (
            <div className="modal-section">
              <div className="form-grid">
                <div className="form-group full">
                  <label className="form-label">PrÃ³xima acciÃ³n</label>
                  <input className="form-input" value={salesModalForm.proxima_accion || ''} onChange={(e) => updateForm({ proxima_accion: e.target.value })} placeholder="Ej: Continuar calificaciÃ³n comercial" />
                </div>
                <div className="form-group full">
                  <label className="form-label">ObservaciÃ³n</label>
                  <textarea className="form-input" style={{ minHeight: 80, resize: 'vertical' }} value={salesModalForm.observacion || ''} onChange={(e) => updateForm({ observacion: e.target.value })} />
                </div>
              </div>
            </div>
          )}

          {/* â”€â”€ CALIFICAR â”€â”€ */}
          {tipo === 'calificar' && (
            <div className="modal-section">
              <div className="form-grid">
                <div className="form-group">
                  <label className="form-label">Resultado</label>
                  <select className="form-select" value={salesModalForm.resultado_calificacion || 'calificado'} onChange={(e) => updateForm({ resultado_calificacion: e.target.value })}>
                    <option value="calificado">Calificado</option>
                    <option value="descartar">Descartar</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">PrÃ³xima acciÃ³n</label>
                  <input className="form-input" value={salesModalForm.proxima_accion || ''} onChange={(e) => updateForm({ proxima_accion: e.target.value })} placeholder="Ej: Validar cobertura" />
                </div>
                <div className="form-group full">
                  <label className="form-label">ObservaciÃ³n</label>
                  <textarea className="form-input" style={{ minHeight: 80, resize: 'vertical' }} value={salesModalForm.observacion || ''} onChange={(e) => updateForm({ observacion: e.target.value })} />
                </div>
              </div>
            </div>
          )}

          {/* â”€â”€ COBERTURA â”€â”€ */}
          {tipo === 'cobertura' && (
            <div className="modal-section">
              <div className="form-grid">
                <div className="form-group"><label className="form-label">DirecciÃ³n</label><input className="form-input" value={salesModalForm.direccion || ''} onChange={(e) => updateForm({ direccion: e.target.value })} /></div>
                <div className="form-group"><label className="form-label">Localidad</label><input className="form-input" value={salesModalForm.localidad || ''} onChange={(e) => updateForm({ localidad: e.target.value })} /></div>
                <div className="form-group"><label className="form-label">Entre calle 1 opcional</label><input className="form-input" value={salesModalForm.entre_calle_1 || ''} onChange={(e) => updateForm({ entre_calle_1: e.target.value })} /></div>
                <div className="form-group"><label className="form-label">Entre calle 2 opcional</label><input className="form-input" value={salesModalForm.entre_calle_2 || ''} onChange={(e) => updateForm({ entre_calle_2: e.target.value })} /></div>
                <div className="form-group full">
                  <label className="form-label">Resultado cobertura</label>
                  <select className="form-select" value={salesModalForm.cobertura_resultado || 'cobertura_ok'} onChange={(e) => updateForm({ cobertura_resultado: e.target.value })}>
                    <option value="cobertura_ok">Cobertura OK</option>
                    <option value="sin_cobertura">Sin cobertura</option>
                    <option value="sin_cobertura_expansion">Sin cobertura / guardar para expansiÃ³n</option>
                  </select>
                </div>
                <div className="form-group full"><label className="form-label">ObservaciÃ³n</label><textarea className="form-input" style={{ minHeight: 80, resize: 'vertical' }} value={salesModalForm.observacion || ''} onChange={(e) => updateForm({ observacion: e.target.value })} /></div>
              </div>
            </div>
          )}

          {/* â”€â”€ PROPUESTA â”€â”€ */}
          {tipo === 'propuesta' && (
            <div className="modal-section">
              <div className="form-grid">
                <div className="form-group"><label className="form-label">Plan contratado *{requerido(salesModalForm.plan)}</label><input className="form-input" value={salesModalForm.plan || ''} onChange={(e) => updateForm({ plan: e.target.value })} /></div>
                <div className="form-group"><label className="form-label">Precio *{requerido(salesModalForm.precio)}</label><input className="form-input" value={salesModalForm.precio || ''} onChange={(e) => updateForm({ precio: e.target.value })} /></div>
                <div className="form-group"><label className="form-label">Medio de pago *{requerido(salesModalForm.medio_pago)}</label><input className="form-input" value={salesModalForm.medio_pago || ''} onChange={(e) => updateForm({ medio_pago: e.target.value })} /></div>
                <div className="form-group"><label className="form-label">PrÃ³xima acciÃ³n</label><input className="form-input" value={salesModalForm.proxima_accion || ''} onChange={(e) => updateForm({ proxima_accion: e.target.value })} /></div>
                <div className="form-group full"><label className="form-label">ObservaciÃ³n</label><textarea className="form-input" style={{ minHeight: 80, resize: 'vertical' }} value={salesModalForm.observacion || ''} onChange={(e) => updateForm({ observacion: e.target.value })} /></div>

                <div className="form-group full">
                  <label className="form-label">CatÃ¡logo comercial IA</label>
                  {salesModalForm.catalogo_loading ? (
                    <div className="form-input" style={{ minHeight: 70, whiteSpace: 'pre-wrap', opacity: 0.75 }}>
                      Cargando catÃ¡logo comercial por localidad...
                    </div>
                  ) : salesModalForm.contexto_catalogo ? (
                    <textarea
                      className="form-input"
                      style={{ minHeight: 180, resize: 'vertical', whiteSpace: 'pre-wrap' }}
                      value={salesModalForm.contexto_catalogo}
                      readOnly
                    />
                  ) : (
                    <div className="form-input" style={{ minHeight: 70, whiteSpace: 'pre-wrap', opacity: 0.75 }}>
                      {salesModalForm.catalogo_error || 'Sin contexto de catÃ¡logo disponible para esta localidad.'}
                    </div>
                  )}
                  <div style={{ fontSize: 12, opacity: 0.75, marginTop: 6 }}>
                    Regla facturaciÃ³n: {salesModalForm.regla_facturacion_catalogo || 'No disponible'} · Productos: {salesModalForm.productos_count_catalogo || 0}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* â”€â”€ SEGUIMIENTO â”€â”€ */}
          {tipo === 'seguimiento' && (
            <div className="modal-section">
              <div className="form-grid">
                <div className="form-group"><label className="form-label">PrÃ³xima acciÃ³n</label><input className="form-input" value={salesModalForm.proxima_accion || ''} onChange={(e) => updateForm({ proxima_accion: e.target.value })} /></div>
                <div className="form-group"><label className="form-label">Fecha de seguimiento</label><input type="datetime-local" className="form-input" value={salesModalForm.fecha_seguimiento || ''} onChange={(e) => updateForm({ fecha_seguimiento: e.target.value })} /></div>
                <div className="form-group full"><label className="form-label">ObservaciÃ³n</label><textarea className="form-input" style={{ minHeight: 80, resize: 'vertical' }} value={salesModalForm.observacion || ''} onChange={(e) => updateForm({ observacion: e.target.value })} /></div>
              </div>
            </div>
          )}

          {/* â”€â”€ ACEPTAR â”€â”€ */}
          {tipo === 'aceptar' && (
            <div className="modal-section">
              <div className="form-grid">
                <div className="form-group"><label className="form-label">Plan final</label><input className="form-input" value={salesModalForm.plan || ''} onChange={(e) => updateForm({ plan: e.target.value })} /></div>
                <div className="form-group"><label className="form-label">Precio final</label><input className="form-input" value={salesModalForm.precio || ''} onChange={(e) => updateForm({ precio: e.target.value })} /></div>
                <div className="form-group full"><label className="form-label">ObservaciÃ³n</label><textarea className="form-input" style={{ minHeight: 80, resize: 'vertical' }} value={salesModalForm.observacion || ''} onChange={(e) => updateForm({ observacion: e.target.value })} /></div>
              </div>
            </div>
          )}

          {/* â”€â”€ PERDIDA â”€â”€ */}
          {tipo === 'perdida' && (
            <div className="modal-section">
              <div className="form-grid">
                <div className="form-group full">
                  <label className="form-label">Motivo de pÃ©rdida</label>
                  <select className="form-select" value={salesModalForm.motivo_perdida || 'No responde'} onChange={(e) => updateForm({ motivo_perdida: e.target.value })}>
                    <option>Precio</option><option>Sin cobertura</option><option>Competencia</option>
                    <option>No responde</option><option>PostergÃ³</option><option>Otro</option>
                  </select>
                </div>
                <div className="form-group full"><label className="form-label">ObservaciÃ³n</label><textarea className="form-input" style={{ minHeight: 80, resize: 'vertical' }} value={salesModalForm.observacion || ''} onChange={(e) => updateForm({ observacion: e.target.value })} /></div>
              </div>
            </div>
          )}

          {/* â”€â”€ CONFIRMAR (Resumen interno) â”€â”€ */}
          {tipo === 'confirmar' && (
            <>
              <div className="modal-section">
                <div className="modal-section-title"><span className="dot" style={{ background: '#3b82f6' }} /> Datos del cliente <span className="ia-extracted">âš¡ ExtraÃ­dos por IA</span></div>
                <div className="form-hint">El humano valida estos datos antes de disparar implementaciÃ³n. CUIL/DNI es obligatorio; email no bloquea.</div>
                <div className="form-grid">
                  <div className="form-group"><label className="form-label">Cliente *{requerido(salesModalForm.nombre_apellido)}</label><input className="form-input" value={salesModalForm.nombre_apellido || ''} onChange={(e) => updateForm({ nombre_apellido: e.target.value })} /></div>
                  <div className="form-group"><label className="form-label">CUIL/DNI *{requerido(salesModalForm.cuil)}</label><input className="form-input" value={salesModalForm.cuil || ''} onChange={(e) => updateForm({ cuil: e.target.value })} placeholder="XX-XXXXXXXX-X" /></div>
                  <div className="form-group"><label className="form-label">Email opcional</label><input className="form-input" value={salesModalForm.email || ''} onChange={(e) => updateForm({ email: e.target.value })} /></div>
                  <div className="form-group"><label className="form-label">TelÃ©fono *{requerido(salesModalForm.telefono)}</label><input className="form-input" value={salesModalForm.telefono || ''} onChange={(e) => updateForm({ telefono: e.target.value })} /></div>
                </div>
              </div>

              <div className="modal-section">
                <div className="modal-section-title"><span className="dot" style={{ background: '#f59e0b' }} /> DirecciÃ³n de instalaciÃ³n</div>
                <div className="form-hint">Entre calles son opcionales. Latitud y longitud se intentan completar automÃ¡ticamente desde direcciÃ³n + localidad.</div>
                <div className="form-grid">
                  <div className="form-group full"><label className="form-label">DirecciÃ³n *{requerido(salesModalForm.direccion)}</label><input className="form-input" value={salesModalForm.direccion || ''} onChange={(e) => updateForm({ direccion: e.target.value })} /></div>
                  <div className="form-group"><label className="form-label">Entre calle 1 opcional</label><input className="form-input" value={salesModalForm.entre_calle_1 || ''} onChange={(e) => updateForm({ entre_calle_1: e.target.value })} placeholder="Opcional" /></div>
                  <div className="form-group"><label className="form-label">Entre calle 2 opcional</label><input className="form-input" value={salesModalForm.entre_calle_2 || ''} onChange={(e) => updateForm({ entre_calle_2: e.target.value })} placeholder="Opcional" /></div>
                  <div className="form-group"><label className="form-label">Localidad *{requerido(salesModalForm.localidad)}</label><input className="form-input" value={salesModalForm.localidad || ''} onChange={(e) => updateForm({ localidad: e.target.value })} /></div>
                </div>
              </div>

              <div className="modal-section">
                <div className="modal-section-title"><span className="dot" style={{ background: '#22c55e' }} /> Plan y forma de pago</div>
                <div className="form-grid">
                  <div className="form-group"><label className="form-label">Plan contratado *{requerido(salesModalForm.plan)}</label><input className="form-input" value={salesModalForm.plan || ''} onChange={(e) => updateForm({ plan: e.target.value })} /></div>
                  <div className="form-group"><label className="form-label">Precio *{requerido(salesModalForm.precio)}</label><input className="form-input" value={salesModalForm.precio || ''} onChange={(e) => updateForm({ precio: e.target.value })} /></div>
                  <div className="form-group"><label className="form-label">Medio de pago *{requerido(salesModalForm.medio_pago)}</label><input className="form-input" value={salesModalForm.medio_pago || ''} onChange={(e) => updateForm({ medio_pago: e.target.value })} /></div>
                  <div className="form-group full"><label className="form-label">ObservaciÃ³n interna</label><textarea className="form-input" style={{ minHeight: 70, resize: 'vertical' }} value={salesModalForm.observaciones || ''} onChange={(e) => updateForm({ observaciones: e.target.value })} /></div>
                </div>
              </div>

              <div className="modal-section">
                <div className="modal-section-title"><span className="dot" style={{ background: '#0088cc' }} /> Preview mensaje Telegram</div>
                <div className="modal-preview">{telegramPreview}</div>
                <div className="form-hint" style={{ marginTop: 6 }}>Este mensaje se enviarÃ¡ al grupo de Telegram al confirmar la venta.</div>
              </div>
            </>
          )}
        </div>

        <div className="modal-footer">
          <button className="modal-btn cancel" onClick={cerrarModalVentas}>Cancelar</button>
          <button className="modal-btn confirm" onClick={guardarAccionVentasModal} disabled={submittingSalesModal}>
            {submittingSalesModal ? (tipo === 'confirmar' ? 'Confirmando...' : 'Guardando...') : tipo === 'confirmar' ? 'âœ… Confirmar venta y enviar a implementaciÃ³n' : 'âœ“ Guardar'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default React.memo(SalesModal);

